import Vue from 'vue';
import personalInfoTransformer from './../../transformers/custom/registerPersonalInfo';

const success = (resolve) => {
  Vue.router.push({
    name: 'register.done',
  });
  resolve();
};

const failed = (errors, reject) => {
  reject(personalInfoTransformer.fetch(errors));
};

export default user => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post('auth/personal-information', user)
      .then(() => {
        success(resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/auth/personalInfo.js